export default {"src":"/_next/static/media/sitprice.4849b5d2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};